export const common = (t) => ({
	UI_SPIN: {
		value: 'SPIN',
		config: {
			fill: '#faf6e4',
			fontFamily: 'Poppins Bold',
			fontWeight: 'bold',
			fontSize: 74
		}
	},
	UI_AUTO: {
		value: 'A',
		config: {
			fill: '#faf6e4',
			fontFamily: 'Poppins Bold',
			fontWeight: 'bold',
			fontSize: 44
		}
	},
	UI_FAST: {
		value: 'F',
		config: {
			fill: '#faf6e4',
			fontFamily: 'Poppins Bold',
			fontWeight: 'bold',
			fontSize: 44
		}
	},
	UI_DOUBLE_CHANCE_ON: {
		value: 'ON',
		config: {
			fill: '#CBCAEA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	UI_DOUBLE_CHANCE_OFF: {
		value: 'OFF',
		config: {
			fill: '#CBCAEA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	UI_DOUBLE_CHANCE_VALUE: {
		value: '$10.00',
		config: {
			fill: ['#9b61e4', '#6c25b4'],
			fontFamily: 'Poppins Bold',
			fontSize: 42
		}
	},
	UI_DOUBLE_CHANCE_TITLE: {
		value: t('common.ui_double_chance_title'),
		config: {
			fill: '#bab5db',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18,
			lineHeight: 22,
			wordWrap: true,
			wordWrapWidth: 170
		}
	},
	UI_DOUBLE_CHANCE_SUBTITLE: {
		value: t('common.feature'),
		config: {
			fill: ['#7eba21', '#447e15'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 18,
			lineHeight: 42
		}
	},
	UI_BET_AMOUNT_TITLE: {
		value: 'BET AMOUNT',
		config: {
			fill: '#7571CA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 16
		}
	},
	UI_BET_AMOUNT_VALUE: {
		value: '',
		config: {
			fill: '#CBCAEA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	UI_BONUS_BUY_VALUE: {
		value: '$400',
		config: {
			fill: ['#92cf25', '#225a0f'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 32
		}
	},
	UI_BONUS_REVIVE_VALUE: {
		value: '$400',
		config: {
			fill: ['#92cf25', '#225a0f'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 32
		}
	},
	UI_STATUS_BAR_COPY: {
		value: t('common.good_luck'),
		config: {
			fill: '#B3B2DE',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	UI_STATUS_BAR_WIN_LABEL: {
		value: t('bonus.win'),
		config: {
			fill: '#D0DEB2',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	UI_STATUS_BAR_WIN_VALUE: {
		value: '0',
		config: {
			fill: '#69AB15',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	UI_STATUS_BAR_BALANCE_TITLE: {
		value: 'BALANCE',
		config: {
			fill: '#B3B2DE',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	UI_STATUS_BAR_BALANCE_VALUE: {
		value: '$100.00',
		config: {
			fill: '#4B32E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	UI_FTR_QUEST_TITLE: {
		value: 'THE LOST SCROLL',
		config: {
			fill: ['#92CF25', '#225A0F'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	UI_FTR_QUEST_SUBTITLE: {
		value: 'Refreshes in',
		config: {
			fill: '#CFDBB5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	UI_FTR_QUEST_TIMER: {
		value: '',
		config: {
			fill: '#CFDBB5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	UI_QUEST_TIMER_ICON: {
		value: '',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20
		}
	},
	UI_QUEST_DAILY_TITLE: {
		value: 'Complete All Daily Quests',
		config: {
			fill: '#B7EE71',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	UI_QUEST_DAILY_SUBTITLE: {
		value: 'Claim all rewards',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20
		}
	},
	UI_QUEST_ITEM_DAILY_BTN: {
		value: 'GO',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	UI_SETTINGS_ITEM_HEADER: {
		value: '',
		config: {
			fill: '#5C4F86',
			fontFamily: 'Poppins Bold',
			fontSize: 18
		}
	},
	UI_SETTINGS_ITEM_SETT: {
		value: '',
		config: {
			fill: '#ffffff',
			fontFamily: 'Poppins Bold',
			fontSize: 24
		}
	},
	UI_SETTINGS_ITEM_DESC: {
		value: '',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Bold',
			fontSize: 18
		}
	},
	UI_SETTINGS_ITEM_HEADER_SFX: {
		value: 'SOUND & FX'
	},
	UI_SETTINGS_ITEM_HEADER_FUNC: {
		value: 'FUNCTIONAL'
	},
	UI_SETTINGS_ITEM_HEADER_VISUAL: {
		value: 'VISUAL'
	},
	UI_SETTINGS_ITEM_SFX_BG: {
		value: 'BACKGROUND MUSIC'
	},
	UI_SETTINGS_ITEM_SFX_BG_DESC: {
		value: 'TURN ON THE GAME MUSIC'
	},
	UI_SETTINGS_ITEM_SFX_SE: {
		value: 'SOUND EFFECTS'
	},
	UI_SETTINGS_ITEM_SFX_SE_DESC: {
		value: 'TURN OFF GAME SOUNDS'
	},
	UI_SETTINGS_ITEM_FUNC_RS: {
		value: 'RAPID SPIN'
	},
	UI_SETTINGS_ITEM_FUNC_RS_DESC: {
		value: 'ULTRA RAPID SPINNING SPEED'
	},
	UI_SETTINGS_ITEM_FUNC_GA: {
		value: 'GAME ANIMATIONS '
	},
	UI_SETTINGS_ITEM_FUNC_GA_DESC: {
		value: 'IN CASE OF LOW-BANDWITCH'
	},
	UI_SETTINGS_ITEM_VISUAL_TS: {
		value: 'TRANSITION SCREENS '
	},
	UI_SETTINGS_ITEM_VISUAL_TS_DESC: {
		value: 'BONUS ROUND GREETING'
	},
	UI_SETTINGS_ITEM_FUNC_SS: {
		value: t('settings.splash_screen')
	},
	UI_SETTINGS_ITEM_FUNC_SS_DESC: {
		value: 'GAME WELCOMING SCREEN'
	},
	UI_QUEST_ITEM_HEADER: {
		value: '',
		config: {
			fill: '#ffffff',
			fontFamily: 'Poppins Bold',
			fontSize: 24
		}
	},
	UI_QUEST_ITEM_SUBTITLE: {
		value: '',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Bold',
			fontSize: 18
		}
	},
	UI_QUEST_ITEM_DESC: {
		value: '',
		config: {
			fill: '#3E54FA',
			fontFamily: 'Poppins Bold',
			fontSize: 18
		}
	},
	UI_QUEST_ITEM_HEADER_1: {
		value: 'Catch 3x Alien Symbol'
	},
	UI_QUEST_ITEM_SUBTITLE_1: {
		value: 'Bet relevant'
	},
	UI_QUEST_ITEM_DESC_1: {
		value: '50 freespin'
	},
	UI_QUEST_ITEM_HEADER_2: {
		value: 'Trigger Min. 2x Scatter'
	},
	UI_QUEST_ITEM_SUBTITLE_2: {
		value: 'Bet relevant free'
	},
	UI_QUEST_ITEM_DESC_2: {
		value: 'Bonus Round'
	},
	UI_QUEST_ITEM_HEADER_3: {
		value: 'Trigger Min. 2x Scatter'
	},
	UI_QUEST_ITEM_SUBTITLE_3: {
		value: 'Bet relevant'
	},
	UI_QUEST_ITEM_DESC_3: {
		value: 'Bonus Discount'
	},
	UI_QUEST_ITEM_HEADER_4: {
		value: 'Trigger Min. 2x Scatter'
	},
	UI_QUEST_ITEM_SUBTITLE_4: {
		value: 'Bet relevant'
	},
	UI_QUEST_ITEM_DESC_4: {
		value: '20% Bonus Discount'
	},
	UI_QUEST_ITEM_CLAIM_HEADER: {
		value: '',
		config: {
			fill: 'ffffff',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	UI_QUEST_ITEM_CLAIM_SUBTITLE: {
		value: '',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18,
			wordWrap: true,
			wordWrapWidth: 170
		}
	},
	UI_QUEST_CLAIM_ITEM_HEADER_1: {
		value: '50 Freespin'
	},
	UI_QUEST_CLAIM_ITEM_HEADER_2: {
		value: 'Bonus Round'
	},
	UI_QUEST_CLAIM_ITEM_HEADER_3: {
		value: 'Bonus Discount'
	},
	UI_QUEST_CLAIM_ITEM_HEADER_4: {
		value: 'Wild Respin'
	},
	UI_QUEST_CLAIM_ITEM_DESC_1: {
		value: 'Get extra chances to play and keep win'
	},
	UI_QUEST_CLAIM_ITEM_DESC_2: {
		value: 'Get into free bonus round and try fortune'
	},
	UI_QUEST_CLAIM_ITEM_DESC_3: {
		value: 'Get 20% of required bonus buy amount'
	},
	UI_QUEST_CLAIM_ITEM_DESC_4: {
		value: 'Get 3x random sticky wild respin on reel'
	},
	GOOD_LUCK: {
		value: t('common.good_luck')
	},
	DOUBLE_CHANCE: {
		value: t('common.double_chance')
	},
	TURNED_ON: {
		value: t('common.turned_on')
	},
	TURNED_OFF: {
		value: t('common.turned_off')
	},
	BUY_BONUS: {
		value: t('bonusWidget.buy_bonus')
	},
	FAST_SPIN: {
		value: t('autoSpin.fast_spin')
	},
	MUSIC: {
		value: t('settings.music')
	},
	SOUND: {
		value: t('settings.sound')
	},
	SHORTCUTS: {
		value: t('settings.shortcuts')
	},
	BACKGROUND_MUSIC: {
		value: t('settings.background_music')
	},
	ANIMATIONS: {
		value: t('settings.animations')
	},
	PAYS: {
		value: t('common.pays')
	},
	EXPIRED_SESSION: {
		value: t('errors.expiredSession')
	}
});
